module.exports = __webpack_public_path__ + "static/media/46ba6033.jpg";